/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {SelectOption} from '../../../../../../models/utility.model'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useGuests} from '../../../../hooks/useGuests'
import {RatioRoomingListData} from '../../../../models/reports.model'
import {
  getRatioRoomingListCSVService,
  getRatioRoomingListExcelService,
  getRatioRoomingListPDFService,
} from '../../../../services/ratio.service'

interface Props {
  datos: RatioRoomingListData[]
  loading: boolean
  getRatios: (data: any) => void
  siteSelected: string | null
  formValue: any
  total: number
}

const TableReportRatioRoomingList: FC<Props> = ({
  datos,
  loading,
  getRatios,
  siteSelected,
  formValue,
  total,
}) => {
  const {setPagination, pagination, updateTable, setUpdateTable, clearTable, setClearTable} =
    useKTable()
  console.log('updateTable', updateTable)
  const [statusType, setStatusType] = useState<SelectOption[]>([])
  const [bedTypes, setBedTypes] = useState<SelectOption[]>([])
  const [companyType, setCompanyType] = useState<SelectOption[]>([])
  const [guests, setGuests] = useState<SelectOption[]>([])
  const [enterprises, setEnterprises] = useState<SelectOption[]>([])
  const [typeGuestStayList, setTypeGuestStayList] = useState<SelectOption[]>([])
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)

  const {getMasterTable, getEnterprises, getDocumentTypesByCode} = useCentralServices()
  const {getGuests} = useGuests()

  const camaCaliente = [
    {value: 'SI', label: 'SI'},
    {value: 'NO', label: 'NO'},
  ]

  ///
  ///
  useEffect(() => {
    getBedTypesFn()
    getCompanyTypesFn()
    getStatusTypesFn()
    getEnterprisesFn()
    getTypeGuestStayListFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getBedTypesFn = async () => {
    const data = await getMasterTable('TipoCama', true)
    setBedTypes(data)
  }

  const getCompanyTypesFn = async () => {
    const data = await getMasterTable('TipoEmpresa', true)
    setCompanyType(data)
  }

  const getStatusTypesFn = async () => {
    const data = await getMasterTable('EstadoReservaCamaHuesped', true)
    setStatusType(data)
  }

  const getTypeGuestStayListFn = async () => {
    const data = await getMasterTable('TipoEstadiaHuesped', true)
    setTypeGuestStayList(data)
  }

  const getGuestsFn = async (siteId: string | null) => {
    const data = await getGuests({pageNumber: 1, size: 2000, SiteId: siteId})
    setGuests(data)
  }

  const getEnterprisesFn = async () => {
    const data = await getEnterprises({isCombo: true}, 1)
    setEnterprises(data)
  }

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getRatios({})
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getRatios({})
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  // useEffect(() => {
  //   getGuestsFn(siteSelected)
  // }, [siteSelected])

  useEffect(() => {
    getRatios({pageNumber: pagination.currentPage, size: pagination.perPage})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    setPagination({...pagination, totalResults: total})
  }, [total])

  const columns: Column<RatioRoomingListData>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
        accessor: 'CampamentoNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            searcheable
            name='CodigoModulo'
          />
        ),
        accessor: 'ModuloCodigo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Reserva' name='NroReserva' searcheable />
        ),
        accessor: 'NroReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='CodigoHabitacion'
            searcheable
          />
        ),
        accessor: 'HabitacionCodigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CodigoCama'
            searcheable
          />
        ),
        accessor: 'CamaCodigo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de cama'
            name='TipoCamaId'
            selecteable
            data={bedTypes}
          />
        ),
        accessor: 'TipoCamaNombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado de cama' />,
        accessor: 'EstadoCamaNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cama Caliente'
            name='CamaCaliente'
            selecteable
            data={camaCaliente}
          />
        ),
        accessor: 'CamaCaliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estatus Huésped'
            name='tipoEstadiaId'
            data={typeGuestStayList}
            selecteable
          />
        ),
        accessor: 'TipoEstadia',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='EstadoReservaCamaId'
            data={statusType}
            selecteable
          />
        ),
        accessor: 'EstadoReservaCamaNombre',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Doc.' name='NroDoc' searcheable />
        ),
        accessor: 'NroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huésped'
            name='HuespedNombres'
            searcheable
            // data={guests}
          />
        ),
        accessor: 'HuespedNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Lotización'
            name='lotizacionEmpresa'
            searcheable
          />
        ),
        accessor: 'LotizacionEmpresa',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ruc' />,
        accessor: 'RucHuespedEmpresaNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Subcontratista'
            name='EmpresaId'
            selecteable
            data={enterprises}
          />
        ),
        accessor: 'HuespedEmpresaNombre',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Check in' name='FechaCheckIn' dateable />
        ),
        accessor: 'FechaCheckIn',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha CheckOut Programada'
            name='FechaReservaFin'
            dateable
          />
        ),
        accessor: 'FechaFinReserva',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Check out' name='FechaCheckOut' dateable />
        ),
        accessor: 'FechaCheckOut',
      },
    ],
    [bedTypes, companyType, statusType, guests, enterprises, typeGuestStayList],
  )

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const response = await getRatioRoomingListExcelService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Rooming List-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const response = await getRatioRoomingListCSVService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Rooming List-${moment().format('DD/MM/YY HH:mm').toString()}.csv` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      setIsDownloadCSV(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const response = await getRatioRoomingListPDFService(formValue)
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Rooming List-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadPDF(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadPDF(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={datos} columns={columns} />
      </KTCard>
    </>
  )
}

const TableReportRatioRoomingListWrapper: FC<Props> = ({
  datos,
  loading,
  getRatios,
  siteSelected,
  formValue,
  total,
}) => {
  return (
    <KTableProvider>
      <TableReportRatioRoomingList
        datos={datos}
        loading={loading}
        getRatios={getRatios}
        siteSelected={siteSelected}
        formValue={formValue}
        total={total}
      />
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableReportRatioRoomingListWrapper}
